/**
 * About — required by E-4. The honesty paragraph below is paraphrased from
 * `.specify/memory/constitution.md` § VII; the constitution is the source of truth.
 */
export function AboutPanel() {
  return (
    <section
      aria-label="About"
      className="flex flex-col gap-3 rounded-md border border-neutral-200 p-3 text-xs text-neutral-600 dark:border-neutral-800 dark:text-neutral-300"
    >
      <h3 className="text-sm font-semibold text-neutral-900 dark:text-neutral-100">About this build</h3>
      <p>
        Claude Design Clone is a self-hostable, single-user tool. It runs entirely in your browser
        with a tiny local proxy. You bring your own Anthropic API key.
      </p>
      <p>
        This is <strong>not</strong> the real{' '}
        <a
          className="underline"
          href="https://claude.ai/design"
          target="_blank"
          rel="noopener noreferrer"
        >
          claude.ai/design
        </a>
        . This clone does not have org-scoped sharing, multiplayer editing, the official Canva
        export integration, the managed &ldquo;import your codebase, infer a design system&rdquo;
        pipeline, or the production &ldquo;Handoff to Claude Code&rdquo; bundle. Use the real
        product for those.
      </p>
      <p className="font-mono text-[11px] text-neutral-400">
        version v0.1.0 · build {(import.meta.env.VITE_GIT_SHA as string | undefined) ?? 'dev'}
      </p>
    </section>
  );
}
